import React from 'react'

export const RenderAccordion = (props) => {
  return (
    <wb-accordion theme="light" prevent-mobile-flyout>
      <wb-accordion-item>
        <wb-accordion-toggle>{props.title}</wb-accordion-toggle>
        <wb-accordion-section>
          <wb-accordion-mobile-header className="wb-type-heading-xs">
            Close
          </wb-accordion-mobile-header>
          <wb-accordion-content>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(4, 1fr)',
                gridGap: '1rem',
              }}
            >
              {props.children}
            </div>
          </wb-accordion-content>
        </wb-accordion-section>
      </wb-accordion-item>
    </wb-accordion>
  )
}
